// extracted by mini-css-extract-plugin
module.exports = {"hero":"Hero_hero__A8Arz","content":"Hero_content__rmktm","date":"Hero_date__ekgjp","cta":"Hero_cta__XoUm5"};